interface IChatRoomAuthorizedAPI {
  CanAccessChat: boolean;
  CanAccessFeaturedChat: boolean;
  FeaturedRoomReason: string;
  IsModerator: boolean;
  Reason: string;
  VideoCanBroadcast: boolean;
  VideoCanView: number;
  RemainingTime: number;
  CanWhisper: boolean;
}

export class ChatRoomAuthorized {
  canAccessChat: boolean;
  canAccessFeaturedChat: boolean;
  featuredRoomReason: string;
  isModerator: boolean;
  reason: string;
  videoCanBroadcast: boolean;
  videoCanView: number;
  remainingTime: number;
  canWhisper: boolean;

  CanAccessFeaturedChat: boolean;
  FeaturedRoomReason: string;
  IsModerator: boolean;
  Reason: string;
  VideoCanBroadcast: boolean;
  VideoCanView: number;
  RemainingTime: number;
  CanWhisper: boolean;

  constructor() {
    this.canAccessChat = false;
    this.canAccessFeaturedChat = false;
    this.featuredRoomReason = '';
    this.isModerator = false;
    this.reason = '';
    this.videoCanBroadcast = false;
    this.videoCanView = 0;
    this.remainingTime = 0;
    this.canWhisper = false;

    this.CanAccessFeaturedChat = false;
    this.FeaturedRoomReason = '';
    this.IsModerator = false;
    this.Reason = '';
    this.VideoCanBroadcast = false;
    this.VideoCanView = 0;
    this.RemainingTime = 0;
    this.CanWhisper = false;
  }

  static mappingObject(_obj: IChatRoomAuthorizedAPI): ChatRoomAuthorized {
    const obj = Object.assign(new ChatRoomAuthorized(), _obj);
    obj.canAccessChat = _obj.CanAccessChat || false;
    obj.canAccessFeaturedChat = _obj.CanAccessFeaturedChat || false;
    obj.featuredRoomReason = _obj.FeaturedRoomReason || '';
    obj.isModerator = _obj.IsModerator || false;
    obj.reason = _obj.Reason || '';
    obj.videoCanBroadcast = _obj.VideoCanBroadcast || false;
    obj.videoCanView = _obj.VideoCanView || 0;
    obj.remainingTime = _obj.RemainingTime || 0;
    obj.canWhisper = _obj.CanWhisper || false;
    return obj;
  }
}
